import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-blankslate',
  templateUrl: './blankslate.component.html',
  styleUrls: ['./blankslate.component.scss']
})
export class BlankslateComponent implements OnInit {

  @Input() height?: string;
  constructor() { }

  ngOnInit() {
  }

}
